// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"d3ce00127808384ad4f3","339":"e2e407f6cdebdbdcde57"}[chunkId] + ".js";
};